module.exports = __webpack_public_path__ + "img/turbo-features11.409bdc0a.png";